module.exports = __webpack_public_path__ + "img/jgsb1.818ae3d4.png";